export default __webpack_public_path__ + "static/media/red-king.486dfc20.png";